import React from 'react';

const BackgroundText = (props) => {
	return(

		<div className = "BackgroundText">
			<h2>{props.text}</h2>
		</div>

		)
}

export default BackgroundText;